import { withBemMod } from '@bem-react/core';
import { compose } from '@bem-react/core';
import { Icon as IconBase } from '@yandex-lego/components/Icon/desktop';
import React, { FC, ReactElement } from 'react';
import {
    withTypeMail as withIconTypeMail,
    withSizeM as withIconSizeM,
} from 'components/Icon';

import { cnMethodSelector } from '../../MethodSelector';
import { MethodSelectorOptionContentProps } from '../MethodSelector-OptionContent.interface';
import { getMethods } from '../../MethodSelector.util';

export interface WithTypeEmail {
    type?: 'email';
}

const Icon = compose(
    withIconSizeM,
    withIconTypeMail,
)(IconBase);

const methods = getMethods();

export const withTypeEmail = withBemMod<WithTypeEmail, MethodSelectorOptionContentProps>(
    cnMethodSelector('OptionContent'),
    { type: 'email' },
    (OptionContent): FC<WithTypeEmail & MethodSelectorOptionContentProps> => (
        (props: WithTypeEmail & MethodSelectorOptionContentProps): ReactElement => {
            const {
                method,
            } = props;

            return (
                <OptionContent {...props}>
                    <Icon
                        type="mail"
                        size="m"
                    />
                    <span className={cnMethodSelector('OptionContentText')}>
                        {methods[method]}
                    </span>
                </OptionContent>
            );
        }
    ),
);
